import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';

@Injectable()
export class ProdutosService {

    private URL_API = environment.urlApi + '/api/produtos';
    private DRAFTS_KEY = 'bth_store_drafts';
    private STORAGE_TOKEN_KEY = 'bth_store_access_token';

    constructor(private httpClient: HttpClient) {
        this.initDrafts();
    }

    getToken(): string {
        return localStorage.getItem('bth_store_access_token');
    }

    setToken(token: string): void {
        localStorage.setItem(this.STORAGE_TOKEN_KEY, token);
    }

    removeToken(): void {
        localStorage.removeItem(this.STORAGE_TOKEN_KEY);
    }

    private getHeaders(): any {
        const token: string = localStorage.getItem(this.STORAGE_TOKEN_KEY);
        if (!token && !token.length) {
            return;
        }
        return {headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'}};
    }

    getProduct(id: string): Promise<any> {
        return this.httpClient.get<any>(`${this.URL_API}/item/${id}`, this.getHeaders()).toPromise();
    }

    getAll(): Promise<any> {
        return this.httpClient.get<any>(`${this.URL_API}`, this.getHeaders()).toPromise();
    }

    add(product: any): Promise<any> {
        return this.httpClient.post<any>(`${this.URL_API}`, product, this.getHeaders()).toPromise();
    }

    removePublication(id: string): Promise<any> {
        return this.httpClient.delete<any>(`${this.URL_API}/${id}`, this.getHeaders()).toPromise();
    }

    update(produto: any): Promise<any> {
        return this.httpClient.put<any>(`${this.URL_API}`, produto, this.getHeaders()).toPromise();
    }

    initDrafts(): void {
        if (!localStorage.getItem(this.DRAFTS_KEY)) {
            localStorage.setItem(this.DRAFTS_KEY, '[]');
        }
    }

    getDrafts(): Array<any> {
        return JSON.parse(localStorage.getItem(this.DRAFTS_KEY));
    }

    setDraft(draft: any): Promise<any> {
        return new Promise<any>((resolve) => {
            const drafts: Array<any> = this.getDrafts();
            if (!draft.ehPublicado) {
                const index: number = drafts.findIndex(localDraft => localDraft.idLoja === draft.idLoja);
                if (index > -1) {
                    drafts.splice(index, 1);
                }
            }
            drafts.push(draft);
            localStorage.setItem(this.DRAFTS_KEY, JSON.stringify(drafts));
            resolve(null);
        });
    }

    findDraft(id: string): any {
        return this.getDrafts().find(draft => String(draft.idLoja) === String(id));
    }

    deleteDraft(draft: any): any {
        const drafts: Array<any> = this.getDrafts();
        const index: number = drafts.findIndex(localDraft => localDraft.idLoja === draft.idLoja);
        if (index > -1) {
            drafts.splice(index, 1);
            localStorage.setItem(this.DRAFTS_KEY, JSON.stringify(drafts));
        }
    }

    updloadImage(formData: FormData): Promise<any> {
        return this.httpClient.post<any>(environment.urlApi + '/upload', formData, {withCredentials: true}).toPromise();
    }
}
